
import { supabase } from "@/integrations/supabase/client";
import { clearCache } from './cache';

/**
 * Creates a checkout session for subscription
 */
export async function createCheckoutSession(userId: string, type: 'monthly' | 'yearly'): Promise<string> {
  try {
    console.log(`Creating ${type} checkout session for user ${userId}`);
    
    // Check if we already have a URL stored for this session
    const cachedUrl = sessionStorage.getItem(`checkout_url_${type}`);
    if (cachedUrl) {
      console.log('Using cached checkout URL to prevent flashing');
      return cachedUrl;
    }
    
    const { data, error } = await supabase.functions.invoke('create-checkout', {
      body: { 
        userId,
        type
      }
    });

    if (error) {
      console.error('Checkout error from Supabase function:', error);
      throw new Error(error.message || 'Failed to create checkout session');
    }

    if (!data?.url) {
      console.error('No checkout URL in response:', data);
      throw new Error('No checkout URL received from payment processor');
    }

    // Set flag for subscription initiation
    localStorage.setItem('subscription_initiated', 'true');
    
    // Clear cache to force a fresh check after checkout
    clearCache(userId);
    
    // Store URL in session storage to prevent repeated calls
    sessionStorage.setItem(`checkout_url_${type}`, data.url);
    
    console.log('Received checkout URL:', data.url);
    return data.url;
  } catch (error) {
    console.error('Error in createCheckoutSession:', error);
    throw error;
  }
}
